import Basket from "assets/img/svg/basket";
import { useTranslation } from "react-i18next";

type Props = {
    onAdd?: () => void;
    onDelete?: (rowIndex: number) => void;
    columns: readonly { id: string; label: string; isMandatory?: boolean }[];
    rows: ({ id?: string | number } & Record<string, string | number>)[];
    onChange?: (data: {
        columnId: string;
        columnIndex: number;
        rowIndex: number;
        value: string;
        currentValue?: string | number;
    }) => void;
    addButtonLabel?: string;
};

const MultiValueInputRow = ({
    row,
    columns,
    onChange,
    onDelete,
}: {
    row: Props["rows"][number];
    columns: Props["columns"];
    onChange: (data: { columnId: string; columnIndex: number; value: string; currentValue?: string | number }) => void;
    onDelete?: () => void;
}) => {
    return (
        <tr className="h-[30px]! border-b-[1px]! border-[#f2f2f2]!">
            {columns.map((column, i) => {
                const cellValue = row[column.id];
                return (
                    <td key={column.id} className="h-[28px]! px-2!">
                        <input
                            type="text"
                            value={cellValue ?? ""}
                            onChange={(e) =>
                                onChange({
                                    columnId: column.id,
                                    columnIndex: i,
                                    value: e.target.value,
                                    currentValue: cellValue,
                                })
                            }
                            className="text-sm! h-[30px]! leading-none! border-none! outline-none! focus:border-none! focus:outline-none! rounded-sm!"
                        />
                    </td>
                );
            })}
            <td className="relative!">
                <div className="position-relative! top-0! translate-y-1.5!">
                    <Basket width={20} height={20} onClick={onDelete} />
                </div>
            </td>
        </tr>
    );
};

const MultiValueInputTable = ({ onAdd, onDelete, columns = [], rows = [], onChange, addButtonLabel }: Props) => {
    const [t] = useTranslation();

    return (
        <div className="border-[1px]! border-[#EAEAEA]! rounded! p-2!">
            <table className="w-full! border-collapse! table-fixed!">
                <thead>
                    <tr className="border-b-[1px]! border-[#EAEAEA]!">
                        {columns.map((column) => (
                            <th
                                key={column.id}
                                className="text-left! text-xs! text-[#646464]! font-medium! py-1.5! px-2!"
                            >
                                {column.label}
                                {column.isMandatory && <span>*</span>}
                            </th>
                        ))}
                        <th className="w-12!"></th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row, index) => {
                        return (
                            <MultiValueInputRow
                                key={row.id}
                                row={row}
                                columns={columns}
                                onChange={(cellData) =>
                                    onChange?.({
                                        ...cellData,
                                        rowIndex: index,
                                    })
                                }
                                onDelete={() => onDelete?.(index)}
                            />
                        );
                    })}
                </tbody>
            </table>
            <div className="mt-2.5!">
                <button
                    type="button"
                    onClick={onAdd}
                    className="text-xs! border-[1px]! border-dashed! border-[#d1d5db]! text-[#374151]! py-1! px-2! rounded-sm! cursor-pointer!"
                >
                    {addButtonLabel || t("UI.AddLineButton")}
                </button>
            </div>
        </div>
    );
};

export default MultiValueInputTable;
